// extracted by mini-css-extract-plugin
export default {"brandPromo":"tG-z","carousel":"uG-z"};